import {
  getPostHogApiHost,
  getPostHogProjectToken,
  getPostHogUiHost,
} from "@/lib/analytics/env";
import { isPostHogAnalyticsEnabled } from "@/lib/analytics/runtime";

export function getPostHogInitOptions() {
  const apiKey = getPostHogProjectToken();
  const apiHost = getPostHogApiHost();
  if (!apiKey || !apiHost) return null;

  const useProxy = process.env.NEXT_PUBLIC_POSTHOG_PROXY !== "false";
  const resolvedApiHost = useProxy ? "/ingest" : apiHost;

  return {
    api_host: resolvedApiHost,
    ui_host: getPostHogUiHost(apiHost),
    defaults: "2026-01-30" as const,
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    person_profiles: "identified_only" as const,
    persistence: "localStorage+cookie" as const,
    disable_session_recording: false,
    session_recording: {
      maskAllInputs: true,
      maskInputOptions: {
        password: true,
      },
    },
    debug: process.env.NODE_ENV === "development",
  };
}

/** Init on production host; per-user exclusion opts out after session user is known. */
export function shouldInitializePostHog(): boolean {
  return isPostHogAnalyticsEnabled();
}
